import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'
import { cn } from '@app/lib/cn'

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-xs border px-1.5 py-px text-micro font-medium whitespace-nowrap',
  {
    variants: {
      tone: {
        neutral: 'border-hairline bg-kagit text-ink-muted',
        accent: 'border-kordovan/25 bg-kordovan/8 text-kordovan',
        ok: 'border-zeytin/25 bg-zeytin/8 text-zeytin',
        warn: 'border-hardal/30 bg-hardal/10 text-hardal',
        info: 'border-celik/25 bg-celik/8 text-celik',
      },
    },
    defaultVariants: {
      tone: 'neutral',
    },
  },
)

export type BadgeProps = ComponentProps<'span'> & VariantProps<typeof badgeVariants>

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />
}

export { badgeVariants }
